var $name="sticky/setTopIndentToStickyElements",$path="app/modules/sticky/setTopIndentToStickyElements.js",$this={$name,$path,};function setTopIndentToStickyElements(elements) {
  elements.reduce((calculatedIndent, element) => {
    element.style.top = `${calculatedIndent}px`;
    return calculatedIndent + element.offsetHeight;
  }, 0);
}

export default setTopIndentToStickyElements;
